<template>
  <div class="price-promise-block">
    <div class="card-block">
      <div class="title">
        <img src="@/assets/imgs/icon40.png" />
        <span>价格估算</span>
      </div>

      <div class="info">
        <el-form
          :model="ruleForm"
          :rules="rules"
          class="demo-ruleForm"
          label-width="100px"
          ref="ruleForm"
        >
          <el-form-item label="正文字数" prop="num">
            <el-input v-model="ruleForm.num"></el-input>
          </el-form-item>
          <el-form-item label="润色级别" prop="service_level">
            <el-select
              placeholder="请根据需要选择润色级别"
              v-model="ruleForm.service_level"
            >
              <el-option
                label="基础版（590元/千字）"
                value="基础版（590元/千字）"
              ></el-option>
              <el-option
                label="标准版（690元/千字）"
                value="标准版（690元/千字）"
              ></el-option>
              <el-option
                label="高级版（890元/千字）"
                value="高级版（890元/千字）"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="可选服务项目">
            <el-select
              multiple
              placeholder="可选的额外增值服务，可根据需要选择一项或多项，如不需要，可不选择。"
              v-model="ruleForm.service_list"
            >
              <el-option label="中文翻译" value="中文翻译"></el-option>
              <el-option label="加急1天" value="加急1天"></el-option>
              <el-option label="加急2天" value="加急2天"></el-option>
              <el-option label="加急3天" value="加急3天"></el-option>
              <el-option label="加急4天" value="加急4天"></el-option>
              <el-option label="语音指导" value="语音指导"></el-option>
              <el-option label="视频指导" value="视频指导"></el-option>
              <el-option label="论文发表指导" value="论文发表指导"></el-option>
              <el-option
                label="1轮返修不限字数润色"
                value="1轮返修不限字数润色"
              ></el-option>
              <el-option
                label="2轮返修不限字数润色"
                value="2轮返修不限字数润色"
              ></el-option>
              <el-option
                label="3轮返修不限字数润色"
                value="3轮返修不限字数润色"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button @click="submitForm('ruleForm')" type="primary"
              >立即计算</el-button
            >
          </el-form-item>
          <div>
            根据您的选择，该订单的估算报价为：{{
              ruleForm.price || 0
            }}元。您将在完成订单后获得额外积分奖励。您也可以在“<a
              @click="toInformation"
              href="javascript:;"
              rel="noopener noreferrer"
              >个人信息</a
            >”页面进行费用预存，获取更多福利！
          </div>
        </el-form>
      </div>
    </div>

    <div class="card-block">
      <div class="title">
        <img src="@/assets/imgs/icon41.png" />
        <span>定价规则</span>
      </div>

      <div class="info">
        <h2>特别注意</h2>
        <p>
          1.由于我司编辑全部为英语母语且活跃在科研一线的专家学者，多数不懂中文，所以首席编辑将首先对稿件质量进行整体评估，若质量不能满足编辑的理解和进一步润色，我司将不能提供服务。
        </p>
        <p>
          2.建议作者在正文标题下方注明计划投稿期刊，润色专家将针对特定期刊提供针对性服务，同时将根据稿件质量给出投稿建议，以帮助作者降低拒稿风险。
        </p>
        <p>
          3.以上报价均以人民币为结算货币,最小计费单元为10元，不足10元向上补齐，默认按照服务价格开具“论文编辑”内容的增值税发票，若对发票有特殊要求请来信或者在提交稿件时备注说明。
        </p>
        <p>
          4.若经润色后稿件仍被杂志主编或审稿人提出语言问题，作者可凭杂志反馈信息享受免费二次服务。
        </p>

        <table cellspacing="0" class="orange">
          <tbody>
            <tr>
              <td class="background" rowspan="2">基础版</td>
              <td width="165">千词价格（仅计算文章正文字数）</td>
              <td width="145">润色周期</td>
              <td>润色轮次</td>
              <td width="100">编辑级别及适用类型</td>
              <td width="180">可选服务</td>
            </tr>
            <tr>
              <td>
                <p>590元</p>
              </td>
              <td>
                <p>最长7个自然日</p>
              </td>
              <td>
                <p>
                  初始润色 + 一轮返修内容润色（修改量&lt;10%，超出部分额外计费）
                </p>
              </td>
              <td>
                <p>
                  编辑为母语为英语的博士/博后，适用于原稿质量较高，无需对语言逻辑、段落结构等提供额外修改，仅需对用词、语法、短语地道性进行润色的论文。
                </p>
              </td>
              <td class="align-left">
                <p>1. 论文翻译</p>
                <p>2. 时间加急</p>
                <p>3. 语音指导</p>
                <p>4. 视频“面对面”指导</p>
                <p>5. 论文发表指导</p>
                <p>6. 返修服务</p>
              </td>
            </tr>
          </tbody>
        </table>

        <table cellspacing="0" class="blue">
          <tbody>
            <tr>
              <td class="background" rowspan="2">标准版[推荐]</td>
              <td width="165">千词价格（仅计算文章正文字数）</td>
              <td width="145">润色周期</td>
              <td>润色轮次</td>
              <td width="100">编辑级别及适用类型</td>
              <td width="180">可选服务</td>
            </tr>
            <tr>
              <td>
                <p><del>790元</del> 690元</p>
              </td>
              <td>
                <p>最长7个自然日</p>
              </td>
              <td>
                <p>
                  初始润色 + 一轮返修内容润色（修改量&lt;10%，超出部分额外计费）
                </p>
              </td>
              <td>
                <p>
                  编辑为母语为英语的助理教授/副教授，适用于原稿质量中等、存在较多不地道用词用语和部分语句逻辑问题的论文。
                </p>
              </td>
              <td class="align-left">
                <p>1. 论文翻译</p>
                <p>2. 时间加急</p>
                <p>3. 语音指导</p>
                <p>4. 视频“面对面”指导</p>
                <p>5. 论文发表指导</p>
                <p>6. 返修服务</p>
              </td>
            </tr>
          </tbody>
        </table>

        <table cellspacing="0" class="red">
          <tbody>
            <tr>
              <td class="background" rowspan="2">专家版</td>
              <td width="165">千词价格（仅计算文章正文字数）</td>
              <td width="145">润色周期</td>
              <td>润色轮次</td>
              <td width="100">编辑级别及适用类型</td>
              <td width="180">可选服务</td>
            </tr>
            <tr>
              <td>
                <p><del>990元</del> 890元</p>
              </td>
              <td>
                <p>最长7个自然日</p>
              </td>
              <td>
                <p>
                  初始润色 + 一轮返修内容润色（修改量&lt;10%，超出部分额外计费）
                </p>
              </td>
              <td>
                <p>
                  编辑为母语为英语的教授/研究员，适用于原稿质量中下、存在较多语句逻辑问题，或目标期刊水准较高、希望得到编辑对稿件更细致地完善和指导的情况。
                </p>
              </td>
              <td class="align-left">
                <p>1. 论文翻译</p>
                <p>2. 时间加急</p>
                <p>3. 语音指导</p>
                <p>4. 视频“面对面”指导</p>
                <p>5. 论文发表指导</p>
                <p>6. 返修服务</p>
              </td>
            </tr>
          </tbody>
        </table>

        <table cellspacing="0" class="green">
          <tbody>
            <tr>
              <td class="background" rowspan="2">顶级专家协商版</td>
              <td width="165">千词价格（仅计算文章正文字数）</td>
              <td width="145">润色周期</td>
              <td>润色轮次</td>
              <td width="100">编辑级别及适用类型</td>
              <td width="180">可选服务</td>
            </tr>
            <tr>
              <td>
                <p>
                  协商处理（针对 Nature，Science 等高级别论文， 资深教授专家润色
                </p>
              </td>
              <td>
                <p>
                  协商处理(针对NatureScience等高级别论文，资深教授专家润色）
                </p>
              </td>
              <td>
                <p>
                  协商处理（针对 Nature,Science 等高级别论文，
                  资深教授专家润色）
                </p>
              </td>
              <td>
                <p>英语为母语的资深教授专家润色</p>
              </td>
              <td class="align-left">
                <p>1. 论文翻译</p>
                <p>2. 时间加急</p>
                <p>3. 语音指导</p>
                <p>4. 视频“面对面”指导</p>
                <p>5. 论文发表指导</p>
                <p>6. 返修服务</p>
              </td>
            </tr>
          </tbody>
        </table>

        <table cellspacing="0" class="green">
          <tbody>
            <tr>
              <td class="background" rowspan="2">返修服务</td>
              <td width="165">千词价格（仅计算文章正文字数）</td>
              <td width="145">润色周期</td>
              <td>润色轮次</td>
              <td width="100">编辑级别及适用类型</td>
              <td width="180">可选服务</td>
            </tr>
            <tr>
              <td>
                <p>详见下述“6.返修服务”</p>
              </td>
              <td>
                <p>最长5个自然日</p>
              </td>
              <td>
                <p>针对返修轮次</p>
              </td>
              <td>
                <p>由第一轮的责任编辑润色</p>
              </td>
              <td class="align-left">
                <p>1. 论文翻译</p>
                <p>2. 时间加急</p>
                <p>3. 语音指导</p>
                <p>4. 视频“面对面”指导</p>
                <p>5. 论文发表指导</p>
                <p>6. 返修服务</p>
              </td>
            </tr>
          </tbody>
        </table>

        <div>
          <p>
            1.
            论文翻译：“翻译服务以中文字数计费，价格以所选的润色级别为基准。服务周期为14天（7天翻译，7天润色）。确认报价后需支付两千元押金。不负责修改图中文字，若需翻译图中文字，请将要翻译的中文文字单独列出。
          </p>
          <p>
            2.
            时间加急：默认润色周期为7个自然日，每加急一天在原定价基础上增加15%，最短润色周期为3天。
          </p>
          <p>
            3.
            语音指导：润色专家提供长10-15分钟的论文点评/写作指导的录音，在原定价基础上增加20%。
          </p>
          <p>
            4.
            视频“面对面”指导：润色专家与作者（可多人）进行40-60分钟视频，进行论文修改、点评与写作指导。在原定价基础上增加50%。
          </p>
          <p>
            5.
            论文发表指导：润色专家针对论文内容、投稿期刊、答复审稿人方式等方面提供建议，直到论文发表。在原定价基础上增加50%。
          </p>
          <p>
            6.返修服务：前1轮返修内容在10%文字量以内的部分免费润色；1-3轮返修不限字数重新润色分别需额外增加60%，40%，20%的价格。可在初次提交时勾选可选服务，也可在返修后补交差额购买返修服务。
          </p>
        </div>
      </div>
    </div>

    <div class="card-block">
      <div class="title">
        <img src="@/assets/imgs/icon35.png" />
        <span>积分奖励</span>
      </div>

      <div class="info text-indent">
        <h2>单单有积分：</h2>
        <p>
          为了感谢您对我平台的大力支持，我们无限期推出“单单有积分”的奖励活动。您的每笔订单都将获得相应的积分奖励，奖励比例与您所选的服务级别和订单总金额成正比，所选级别越高、每单总金额越高，则兑换比例越高。对应积分将在完成订单后累加到您的账户上，您可在任何时候与我们联系进行积分兑换礼品的操作，或在每年度结算时由我们为您自动兑换。礼品包括：商超或网上商城购物卡、诚意礼品、服务代金券等。
        </p>
        <h2>储值有好礼 ：</h2>
        <p>
          为方便科研工作者，减少财务手续，最大限度利用您的科研经费，我们提供储值服务，该服务受到众多科研成果高产出团队和单位的欢迎。您可在任何时间预存服务费到您的账户，充值后账户余额永不过期，可用于支付本人或他人润色、编辑、数据处理等服务费用。预存储值可以获得额外积分/礼品奖励，积分与储值额度成正比，可同享“单单有积分”的奖励规则。若你需要此服务，我们可预先开具发票，您在收到发票后进行转账。大多数论文高产实验室和研究团队都选择了预存服务，预存和积分奖励详情请邮件垂询。
        </p>
        <h2>节日有祝福 ：</h2>
        <p>
          为回馈广大师生，本平台无限期退出“节日有祝福”的奖励活动。在每年教师节、劳动节和春节三个重要节日，我们将为本平台普通会员进行节日积分奖励，奖励额度将自动累加到您账户之上；对平台超级会员（根据订单总额进行升级），我们将为您邮递专属节日礼品；在节日前后各一周内提交订单，也将获得1.5倍积分奖励。
        </p>
        <h2>满十有赠一 ：</h2>
        <p>
          为了感谢对本平台高频支持的超级会员，我们无限期推出“满十有赠一”的奖励活动。您的账户上累计完成均价在五千元的订单十篇后，将获得一次低于三千元的免费服务；或对您的订单进行一次性三千元减扣；或对您的下一订单提供两倍积分。
        </p>
        <h2>推荐有奖励 ：</h2>
        <p>
          我们相信您在使用过我们的服务后，便会对我们的品质有足够的了解和信心，因此我们希望您将我们的优质服务推荐给朋友、同事、同学和合作伙伴。为感谢您的厚爱与推荐，我们无限期推出“推荐有奖励”活动。当您将我们的服务推荐给他人时，既可帮别人获得高质量的服务，也将获得可观的回报。您的推荐人在完成订单后，我们将根据该订单的级别和总金额，按照比例为您的账户增加积分。您可在任何时候与我们联系进行积分兑换礼品的操作，或在每年度结算时由我们为您自动兑换。礼品包括：商超或网上商城购物卡、诚意礼品、服务代金券等。
        </p>
        <p>
          *您在推荐时，请告知朋友您在本平台上的“邀请码”（可在登录后个人页面查询），并让您的朋友在提交订单时输入您的“邀请码”，订单完成后，系统将根据本次订单的等级和金额为您和您的朋友独立核算奖励积分，实现“赠人玫瑰手有余香！”
        </p>
      </div>
    </div>

    <div class="card-block">
      <div class="title">
        <img src="@/assets/imgs/icon40.png" />
        <span>付款方式</span>
      </div>

      <div class="info">
        <h2>1.银行转账汇款</h2>
        <p>户名：北京文雅信达科技有限公司</p>
        <p>招商银行北京金融街支行账号： 110936956910201</p>
        <img class="payment" src="@/assets/imgs/payment.jpeg" />
        <h2>2.支票支付（支票交付方式请联系客服）</h2>
        <p>户名：北京文雅信达科技有限公司</p>
        <p>招商银行北京金融街支行账号： 110936956910201</p>
        <h2>3.支付宝（方便快捷、推荐）</h2>
        <img class="alipay" src="@/assets/imgs/alipay.png" />
        <p>打开支付宝扫一扫，付款时，请备注好您的个人信息！</p>
        <h2>4.公务卡扫码支付</h2>
        <img class="alipay" src="@/assets/imgs/bank-quankuan.png" />
      </div>
    </div>

    <div class="card-block">
      <div class="title">
        <img src="@/assets/imgs/icon37.png" />
        <span>价格包括</span>
      </div>

      <div class="info">
        <h2>我司将为顾客提供如下材料并免费顺丰快递：</h2>
        <p>1.普通增值税发票；</p>
        <p>2.缴费通知暨服务协议；</p>
        <p>3.润色证明，方便大家的报销及回复投稿杂志；</p>
        <p>4.论文写作指导 PPT总体点评与写作建议；</p>
        <p>5.顾客选择的其他服务材料。</p>
      </div>
    </div>

    <div class="card-block">
      <div class="title">
        <img src="@/assets/imgs/icon35.png" />
        <span>发票类型</span>
      </div>

      <div class="info">
        <h2>
          我司可提供如下类型的发票，请根据需要选择，若需要其他类型发票请与客服联系。
        </h2>
        <p>1.论文编辑费【默认】；</p>
        <p>2.论文翻译费；</p>
        <p>3.论文润色费；</p>
        <p>4.信息检索费；</p>
        <p>5.审稿费；</p>
        <p>6.修改费；</p>
        <p>7.咨询费；</p>
        <p>8.数据处理费等</p>
      </div>
    </div>

    <div class="card-block">
      <div class="title">
        <img src="@/assets/imgs/icon44.png" />
        <span>服务承诺</span>
      </div>

      <div class="info text-indent">
        <h2>可先服务后付款：</h2>
        <p>
          对于高校、科研院所教职员工（需提供准确个人信息），我们提供先修改后付款的便利，尽可能地减少您的等待时间。系统提交稿件后，您只需对收到的报价确认邮件进行回信确认，就可以让订单流入编辑队列，支付或汇款可以在服务过程中或收稿甚至发票之后进行！
        </p>
        <p>
          在岗的博士后、博士、硕士及本科生不享受先修改后付款特权，但您可以让您的导师提交润色申请，申请时需使用导师本人邮箱，请勿使用您的邮箱代替导师发送邮件。
        </p>
        <p>
          发送申请前请先在您的后台填写完整的个人信息，特别是您的手机号码，方便我们在必要的时候联络您。
          支付的最后期限为收到发票后7天内完成。
        </p>
        <p>
          如遇假期等不能及时支付的情况，您还可以从学校财务借款支付或者先自行支付（选择上面付款方式的支付宝支付），等学校财务转账后让我们把您的原支付退回。
        </p>
        <h2>保密承诺：</h2>
        <p>
          本团队已为全球众多顶尖学者尚未发表的论文稿件进行服务，涉及国内外数十家科研院所，包括北京大学、清华大学、南京大学、武汉大学、北京师范大学、中科院、斯坦福大学、波士顿大学、哈佛大学、浙江大学、兰州大学、中山大学、中国地质大学、南京农业大学等。团队成员均为一线科研工作者，故深刻理解作者对文章原创研究和理念的保护，我们全部流程均以保密为首要考虑，所有的编辑均和我们国内外公司签订了具有法律意义的保密协议（受中国和美国法律双重保护），决不会在未经您授权的情况下使用您的任何文件材料和创意。
        </p>
        <p>
          我们的系统会保留您文件的备份材料，但经手的编辑将会在服务结束后30日内清除所有材料并不得再以任何形式利用或保存这些资料。除非遇到质量投诉问题，只有您个人才能进入您的用户数据库阅读您本人的文件材料。此外，用户后台将自动记录恶意入侵者信息并将采用技术手段防止其访问数据库
          。
        </p>
        <p>
          我司每年服务大批研究人员，我们严密的体系和监控系统确保了至今从未有一例泄密情况。我们英美母语专家作为专业领域内的学术大家，更加明白并尊重您的文章的原创性，他们的学术素养和道德标准均不允许他们做出违背学术道德的行为，因此请您放心使用我们的服务！
        </p>
        <h2>服务周期保证：</h2>
        <p>
          对于每一篇论文，我司均与编辑签订按时高质量返回润色稿件的协议，保证可以在协议时间内返回稿件。若超过预定时间，我司将按照协议做出赔偿！
        </p>
        <p>
          服务速度与编辑的工作量、初始文档质量、学科难度以及工作优先级安排相关，质量监控小组可以确保在约定的服务时间内返还稿件，返还时间不取决于您的稿件长度，因此如果您有严格的时间要求，请使用相对应速度的服务。
        </p>
        <h2>多轮次优惠修改：</h2>
        <p>
          文章经我们的编辑润色后，您进一步修改或审稿后您的同事或者审稿人可能会要求您基于文章科学性或可读性上作进一步修改完善，因此我们提供优惠的多轮次润色服务。
        </p>
        <p>
          前1轮返修内容在10%文字量以内的部分免费润色；1轮及以上返修不限字数重新润色各自需额外增加60%的价格。可在初次提交时勾选可选服务，也可在返修后补交差额购买返修服务。润色后增加、重写或修改文字量超过10%再投稿的将被视作新稿件原价处理。
        </p>
        <h2>免费返修+折扣：</h2>
        <p>
          若您的经我司润色后稿件仍被审稿人或编辑明确提出语言问题（需提供审稿人或编辑的审稿评语作为证明，如“论文语言存在较大问题，建议进行润色修改”，但诸如“文章尚存在少量错别字和不通顺地方，建议作者全文检查修改”一般是审稿人普遍的描述，因此不属于语言润色存在重大问题的范畴），我司将提供免费的返修润色，并对于您的下一篇论文提供打8折的优惠。享受此服务需满足：
        </p>
        <p>我司编辑在初次润色时并未对文章提出“进一步修改后再润色”的建议。</p>
        <p>提供主编或审稿人明确指出语言问题的证明。</p>
        <p>
          请注意：对于原稿逻辑/内容/语言问题较多的稿件，我们将在第一次修改的稿件上做出“
          进一步修改后再润色
          ”的建议。这意味着您需要做大量的重写，重写后的稿件享受85%的优惠费用进行二次润色。
        </p>
      </div>
    </div>

    <!-- <div class="card-block">
      <div class="title">
        <img src="@/assets/imgs/icon35.png" />
        <span>促销活动</span>
      </div>

      <div class="info text-indent">
        <h2>储值折扣：</h2>
        <p>为方便广大科研工作者，缩短付款流程，最大限度利用您的科研经费，我们为用户提供了储值服务，该服务受到了众多实验室和科研团队的欢迎。您可以在任何时间通过单位财务转账/科研经费预存充值到您的账户，充值后账户余额无时间限制，永不过期。使用预存充值功能可以节省每次订单的付款时间，并且可以获得相应的积分奖励，充值越多，积分奖励越多。同时，我们也支持预先寄出发票，您可以在收到发票后转账。大多数论文高产实验室和研究团队都采取了预存款服务的方式，充值预存和积分奖励详情请邮件咨询我们。</p>
        <h2>阶梯折扣：</h2>
        <p>对于同一位用户的第二、三篇论文，我们将分别给予95折和9折优惠（与其他活动不同享）。</p>
        <h2>推荐奖励：</h2>
        <p>我们一直致力于为广大科研工作者提供最优质的英文论文修改服务。只要您使用过我们的服务，相信您就会对我们的品质有足够的了解和信心。很多用户一直将我们的优质服务推荐给朋友、同事、同学和合作伙伴，我们也凭借用户的口碑一传十、十传百。为感谢用户一直以来的厚爱，我们特别推出推荐人奖励活动，当您将我们的服务推荐给他人的同时，既帮助别人获得了高质量的服务信息，也可以获得相应的回报，回报形式包括购物卡，精美礼品，润色折扣等，具体回报力度请与客服联系。</p>
        <p>您在推荐时，请告知朋友您在本平台注册时的注册邮箱，并让其在提交订单的备注处备注您的用户邮箱，我们将根据本次订单的金额为您和您的朋友核算奖励积分。当您的积分达到一定阈值时我们的客服将与您取得联系，并根据您的意愿兑换不同形式的奖励。</p>
      </div>
    </div>-->

    <el-alert :closable="false" show-icon title="提示" type="warning">
      <div class="flex">
        <span
          >对报价和上述说明有疑问者，请与我们联系，我们将进行细致解答。</span
        >
        <span @click="toContact" class="tel">联系我们</span>
      </div>
    </el-alert>
  </div>
</template>

<script>
/**
 * @description 论文润色 - 定价与承诺
 */
// import * as api from '@/api/login'

export default {
  name: 'PricePromise',
  data() {
    return {
      ruleForm: {
        num: '', // 正文字数
        service_level: '', // 润色级别
        service_list: '', // 可选服务
        price: '', // 这是计算出来的最终价格展示
      },
      rules: {
        num: [
          { required: true, message: '请输入论文正文字数', trigger: 'blur' },
        ],
        service_level: [
          { required: true, message: '请选择润色级别', trigger: 'change' },
        ],
      },
    }
  },
  created() {},
  methods: {
    /**
     * @description 论文价格计算
     */
    submitForm(formName) {
      const _this = this
      _this.$refs[formName].validate((valid) => {
        if (valid) {
          let _allPrice = 0 // 最终价格

          // 润色级别定价，根据字数定价
          let _wordPrice = 0 // 文字价格。这里的文字价格就指  原定价格
          if (_this.ruleForm.service_level == '基础版（590元/千字）') {
            _wordPrice = _this.ruleForm.num * 0.59
          } else if (_this.ruleForm.service_level == '标准版（690元/千字）') {
            _wordPrice = _this.ruleForm.num * 0.69
          } else if (_this.ruleForm.service_level == '高级版（890元/千字）') {
            _wordPrice = _this.ruleForm.num * 0.89
          }
          // else if (_this.ruleForm.service_level == '定制版（线下协商）') {
          //   console.log( '定制版（线下协商）');
          // } else if (_this.ruleForm.service_level == '二三轮优惠或免费返修') {
          //   console.log( '二三轮优惠或免费返修');
          // }

          // 可选服务定价-根据所选服务的数量与质量
          // 可选服务的总价 = _servicePrice(其他服务) + _urgentPrice(加急时间) + _repairPrice(论文返修)
          let _servicePrice = 0

          // 加急时间的价格，1、2、3、4天，以最高加急天数的价格为准，多选覆盖
          let _urgentPrice = 0

          // 返修服务的价格，2、3、4轮返修，以最高轮次的返修的价格为准，多选覆盖
          let _repairPrice = 0

          // 论文翻译：原定价基础上增加100%，润色周期默认为12天。
          if (_this.ruleForm.service_list.indexOf('中文翻译') > -1) {
            _servicePrice = _servicePrice + _wordPrice * 1
          }

          // 时间加急：默认润色周期为7个自然日，每加急一天在原定价基础上增加15%，最短润色周期为3天。
          if (_this.ruleForm.service_list.indexOf('加急1天') > -1) {
            _urgentPrice = _wordPrice * 0.15 * 1
          }
          if (_this.ruleForm.service_list.indexOf('加急2天') > -1) {
            _urgentPrice = _wordPrice * 0.15 * 2
          }
          if (_this.ruleForm.service_list.indexOf('加急3天') > -1) {
            _urgentPrice = _wordPrice * 0.15 * 3
          }
          if (_this.ruleForm.service_list.indexOf('加急4天') > -1) {
            _urgentPrice = _wordPrice * 0.15 * 4
          }

          // 3. 语音指导：润色专家提供长10-15分钟的论文点评/写作指导的录音，在原定价基础上增加20%。
          if (_this.ruleForm.service_list.indexOf('语音指导') > -1) {
            _servicePrice = _servicePrice + _wordPrice * 0.2
          }

          // 4. 视频“面对面”指导：润色专家与作者（可多人）进行40-60分钟视频，进行论文修改、点评与写作指导。在原定价基础上增加50%。
          if (_this.ruleForm.service_list.indexOf('视频指导') > -1) {
            _servicePrice = _servicePrice + _wordPrice * 0.5
          }

          // 5. 论文发表指导：润色专家针对论文内容、投稿期刊、答复审稿人方式等方面提供建议，直到论文发表。在原定价基础上增加50%。
          if (_this.ruleForm.service_list.indexOf('论文发表指导') > -1) {
            _servicePrice = _servicePrice + _wordPrice * 0.5
          }

          // 6.返修服务：前1轮返修内容在10%文字量以内的部分免费润色；1-3轮返修不限字数重新润色分别需额外增加60%，40%，20%的价格。可在初次提交时勾选可选服务，也可在返修后补交差额购买返修服务。
          if (_this.ruleForm.service_list.indexOf('1轮返修不限字数润色') > -1) {
            _repairPrice = _wordPrice * 0.6
          }
          if (_this.ruleForm.service_list.indexOf('2轮返修不限字数润色') > -1) {
            _repairPrice = _wordPrice * 0.6 + _wordPrice * 0.4
          }
          if (_this.ruleForm.service_list.indexOf('3轮返修不限字数润色') > -1) {
            _repairPrice =
              _wordPrice * 0.6 + _wordPrice * 0.4 + _wordPrice * 0.2
          }

          // 可选服务的总价 = _servicePrice(其他服务) + _urgentPrice(加急时间) + _repairPrice(论文返修)
          _servicePrice = _servicePrice + _urgentPrice + _repairPrice

          // 总价 = 论文字数价格 + 可选服务总价  计算得出的总价保留整数向上补齐
          _allPrice = Math.ceil(_wordPrice + _servicePrice)
          // 最终的价格需要保留整数，最后的个位数字如果不是0的话，需要进一位，十位+1，个位变0
          // 例如 1009 =》 1010    991.78 =》 1000
          _this.ruleForm.price = Math.ceil(_allPrice / 10) * 10
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },

    /**
     * @description 论文价格计算的form初始化
     */
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
    /**
     * @description 联系我们
     */
    toContact() {
      this.$router.push({
        path: '/about',
      })
    },

    /**
     * @description 查看个人信息
     */
    toInformation() {
      if (
        !localStorage.getItem('userInfo') ||
        localStorage.getItem('userInfo') == 'null'
      ) {
        this.$store.dispatch('user/toLogin', { toggle: true })
        return
      }
      this.$router.push({
        path: '/information',
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.price-promise-block {
  .card-block {
    // width: 100%;
    padding: 20px;
    margin: 0 0 40px 0;
    background: #ffffff;
    border: 1px solid #dfdfdf;
    -moz-box-shadow: 15px 15px 0 #dddddd; /* 老的 Firefox */
    box-shadow: 15px 15px 0 #dddddd;

    .title {
      display: flex;
      align-items: center;
      font-size: 24px;
      padding: 0 20px 20px 20px;
      border-bottom: 1px solid #dcdfe6;

      img {
        display: block;
        width: 30px;
        margin: 0 10px 0 0;
      }
    }

    a {
      color: $colorNormal;
    }

    .info {
      padding: 0 20px;

      .el-form {
        margin: 20px 0 0 0;

        .el-select {
          width: 100%;
        }
      }

      p {
        color: #98a5a6;
        line-height: 1.6;
        margin: 0;
      }

      .payment {
        display: block;
        margin: 10px 0;
        width: 100%;
      }

      .alipay {
        display: block;
        margin: 10px 0;
        width: 200px;
      }

      table {
        margin: 20px 0;
        border: 1px solid #e39f24;
        color: #e39f24;

        td {
          border: 1px solid #e39f24;
          color: #e39f24;
          padding: 10px;
          text-align: center;

          p {
            color: #e39f24;
          }
        }

        .align-left {
          text-align: left;
        }

        .background {
          width: 20px;
          padding: 10px 20px;
          background: #e39f24;
          color: #ffffff;
          font-size: 18px;
        }
      }

      .blue {
        border-color: #3d9aba;
        table,
        td {
          color: #3d9aba;
          border-color: #3d9aba;
        }
        p {
          color: #3d9aba;
        }
        .background {
          background: #3d9aba;
          color: #ffffff;
        }
      }

      .red {
        border-color: #ed6e19;
        table,
        td {
          color: #ed6e19;
          border-color: #ed6e19;
        }
        p {
          color: #ed6e19;
        }
        .background {
          background: #ed6e19;
          color: #ffffff;
        }
      }

      .green {
        border-color: #49ad87;
        table,
        td {
          color: #49ad87;
          border-color: #49ad87;
        }
        p {
          color: #49ad87;
        }
        .background {
          background: #49ad87;
          color: #ffffff;
        }
      }
    }

    .text-indent p {
      text-indent: 32px;
    }
  }

  /deep/.el-alert {
    .el-alert__content {
      width: 100%;
    }
    .flex {
      display: flex;
      justify-content: space-between;
    }

    .tel {
      cursor: pointer;
      display: inline-block;
      width: 250px;
      height: 48px;
      line-height: 48px;
      text-align: center;
      color: #ffffff;
      background: #ea870f;
      margin-top: -25px;
    }
  }
}
</style>